import { person } from '../../api/person';
import { BrowserFourdApi } from '.';

export class Person implements person.Api {
  constructor(private fourd: BrowserFourdApi) {}

  selectPerson(request?: person.SelectPersonRequest): Promise<person.Person[]> {
    return this.fourd.twoWayCall<person.SelectPersonRequest, person.Person[]>(
      request,
      (requestId, request) => {
        this.fourd.call4Dv2('person.selectPerson', request, requestId);
      },
      (response) => {
        let responseData;
        try {
          responseData = JSON.parse(response);
        } catch (e) {
          // Unable to parse response.body => response.body is not a stringify object
          responseData = response;
        }
        return responseData;
      }
    );
  }

  openPerson(request: person.OpenPersonRequest): void {
    this.fourd.call4Dv2('person.openPerson', request);
  }

  //   getLists(request: BaseRequest): Promise<person.Person[]> {
  //     return this.fourd.twoWayCall<BaseRequest, person.Person[]>(
  //       request,
  //       (requestId, request) => {
  //         this.fourd.call4Dv2('person.getLists', request, requestId);
  //       },
  //       (response) => {
  //         let responseData;
  //         try {
  //           responseData = JSON.parse(response);
  //         } catch (e) {
  //           // Unable to parse response.body => response.body is not a stringify object
  //           responseData = response;
  //         }
  //         return responseData;
  //       }
  //     );
  //   }
}
